module.exports = __webpack_public_path__ + "img/fun03.7ee82a20.png";